module.exports = __webpack_public_path__ + "img/desktop-3.eb9d8ee9.jpg";